module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-05.5374d8e1.jpg";